import React, { ReactNode } from 'react';

interface Props {
  setDisplayOverlay: (_value: boolean) => void;
  children?: ReactNode;
  hideClose?: boolean;
}

export const OverlayDisplayDiv: React.FC<Props> = ({ setDisplayOverlay, children, hideClose = false }) => {
  return (
    <div
      className={`fixed overflow-hidden inset-0 bg-gray-700 bg-opacity-50 flex items-center justify-center z-50`}
      onKeyDown={(e) => e.code === 'Escape' && setDisplayOverlay(false)}
      onClick={() => setDisplayOverlay(false)}
    >
      <div className="flex flex-col grow h-full items-center justify-center">
        {!hideClose && (
          <button
            title="disable overlay"
            className="flex rounded-full  bg-white/50 p-[0.5rem] mb-[0.25rem]"
            onClick={() => setDisplayOverlay(false)}
          >
            <img className="h-[0.75rem] w-[0.75rem]" src={`/assets/icons/flat/delete.svg`} alt=""></img>
          </button>
        )}
        <div className="overflow-auto">
          <div onClick={(e) => e.stopPropagation()}>{children}</div>
        </div>
      </div>
    </div>
  );
};
